import { Fragment } from 'react';
import { AppPathnames } from '@/config';
import { Link } from '@/navigation';
import ChevronRight from '../../_icons/Chevron-right';

export const BreadCrumbs: React.FC<{
	className?: string;
	crumbs: {
		title: string;
		slug: string;
		pathname: AppPathnames;
	}[];
}> = ({ className, crumbs }) => {
	return (
		<div className={`flex space-x-3 bg-transparent ${className || ''}`}>
			{crumbs.map((crumb, index) => {
				const isLastCrumb = crumbs.length - 1 === index;

				// probably draft mode without title
				if (!crumb.title) {
					return null;
				}
				return (
					<Fragment key={`crumb-${crumb.title}`}>
						<Link
							className="text-gold text-sm font-bold"
							// @ts-expect-error next-intl
							href={{
								pathname: crumb.pathname,
								params: {
									slug: crumb.slug,
								},
							}}
						>
							{crumb.title.toUpperCase()}
						</Link>
						{!isLastCrumb && (
							<span>
								<ChevronRight />
							</span>
						)}
					</Fragment>
				);
			})}
		</div>
	);
};
